// KEYS FOR LOCAL STORAGE
export const KEY_WALLET_TYPE = 'walletType';
